var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_upload",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.93 52v10c0 3.3-2.7 6-6 6h-44c-3.3 0-6-2.7-6-6V52h-4v10c0 5.5 4.5 10 10 10h44c5.5 0 10-4.5 10-10V52h-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.93 15.7V64h4V15.7l12.7 12.6 2.8-2.8L40.93 8l-17.5 17.5 2.9 2.8 12.6-12.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrUpload);
export default __webpack_public_path__ + "static/media/ubr_upload.5bf161ee7d022bd4511dce0ef8b212a1.svg";
export { ForwardRef as ReactComponent };